import React, { lazy, useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { viewOrderTrack } from '../../analytics/tracker/events/menuEvents';
import '../../css/footer.css';
import { isUserLoggedIn } from '../../functions/isUserLoggedIn';
import { getUserId } from '../../webStorage/localStorage';
import { getOrderTypeName } from '../../webStorage/manageOrderType';
import MenuPageFooter from '../appFooter/menuPageFooter';
import MinLoyalty from '../menu/header/minLoyalty';
import { MenuCategoryContext } from '../menu/menu';
import FooterCarosol from './footerCarosol';

const Footer = (props) => {
  const { mall } = useParams();
  const history = useHistory();
  const FCCartFooter = useMemo(
    () => mall && lazy(() => import(/* webpackChunkName:"FCCartFooter"*/ '../FoodCourt/Footer')),
    []
  );
  const FCOrders = useMemo(
    () => mall && lazy(() => import(/* webpackChunkName:"FCOrders"*/ '../FoodCourt/Footer/orders')),
    []
  );
  const globalSetting = useSelector((state) => state.restSetting?.Setting?.settings.global);

  const viewOrderStatus = (orderDetail) => {
    const orderDetails = props.previousOrders[orderDetail];
    viewOrderTrack({
      User_Login_state: isUserLoggedIn(),
      User_ID: getUserId(),
      Order_Type: getOrderTypeName(orderDetails?.order_type, orderDetails?.table_id, true),
      Order_No: orderDetails?.order_no,
      Restaurant_ID: props.restaurantId,
      Restaurant_Name: props.restaurantName,
    });
    history.push(`/orderstatus/order_id/${orderDetails.order_id}`);
  };

  const { shouldShowLoyalty } = useContext(MenuCategoryContext);

  return (
    <>
      <div className='pageFooter z-index-9'>
        {shouldShowLoyalty && props.showMinLoyaltyForCurrentOrderType && <MinLoyalty />}
        {props.previousOrders?.length > 0 && !props.fc ? (
          <div>
            <FooterCarosol
              viewOrderStatus={viewOrderStatus}
              previousOrders={props.previousOrders}
              getCart={props.getCart}
              globalSetting={globalSetting}
            />
          </div>
        ) : null}

        {props.fc ? (
          <>
            <FCOrders />
            <FCCartFooter />
          </>
        ) : (
          <MenuPageFooter setShowOrderTypePopup={props.setShowOrderTypePopup} />
        )}
      </div>
    </>
  );
};

export default Footer;
